module.exports = __webpack_public_path__ + "img/main_market.8478be6b.jpeg";